



















































import {
  ModalMixin, Modal, AsyncBtn, ShowFinally,
  Message, notify, HasTaskMixin,
} from 'mycorems-app-shared';
import { Account, AccountSubscriber } from '../../types';
import repository from './client-subscriber-repository';
import { subscribeToAccounts } from '.';

interface Data {
  columns: object[],
  accounts: Account[],
  selectedAccounts: Account[],
  searchQuery: string|null,
  pagination: {
    rowsPerPage: number,
  },
}

export default HasTaskMixin.extend({
  mixins: [ModalMixin],
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      columns: [
        {
          name: 'name',
          align: 'left',
          field: (account: Account) => account.name,
        },
      ],
      accounts: [],
      selectedAccounts: [],
      searchQuery: null,
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    filteredAccounts(): Account[] {
      if (!this.searchQuery) return this.accounts;
      return this.accounts.filter(
        c => (
          this.searchQuery !== null
          && (c.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) >= 0)
        ),
      );
    },
  },
  watch: {
    userId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    getSelectedString(): string {
      return (this.selectedAccounts.length === 0)
        ? ''
        : `${this.selectedAccounts.length} account${this.selectedAccounts.length > 1 ? 's' : ''} selected.`;
    },
    load(): void {
      this.task = repository.findUnsubscribedClients(this.userId);
      this.task.then((accounts: Account[]) => {
        this.accounts = accounts;
      });
    },
    subscribe(): void {
      const accountIds: string[] = this.selectedAccounts.map(c => c.id);
      this.task = subscribeToAccounts(this.userId, accountIds);
      this.task.then((accountSubscribers: AccountSubscriber[]) => {
        this.$emit('ok', accountSubscribers);
        notify.success(`Subscribed to ${accountSubscribers.length} client(s).`);
        this.clearSelection();
      });
    },
    isSelected(accountId: string): boolean {
      return (this.selectedAccounts.findIndex(sa => sa.id === accountId) >= 0);
    },
    clearSelection(): void {
      this.accounts = this.accounts.filter(a => !this.isSelected(a.id));
      this.selectedAccounts = [];
    },
  },
  components: {
    Modal,
    AsyncBtn,
    ShowFinally,
    Message,
  },
});
